<template>
  <VSnackbar
    v-for="(massage, index) in toastStore.messages"
    :key="index"
    v-model="massage.isOpen"
    location="top"
    width="555"
    timer="true"
    dir="ltr"
    :offset="index + 1"
    :timeout="4 * 1000"
    class="elevation-0 text-white py-0 mt-8"
    :color="getToastColor(massage.toastType)"
    variant="elevated"
  >
    <template #default>
      <VRow>
        <VCol class="pa-0 position-absolute left-0 justify-end d-flex">
          <VBtn
            icon="close"
            variant="text"
            size="small"
            color="white"
            class="pa-0"
            @click.prevent="massage.isOpen = false"
          />
        </VCol>

        <VCol cols="auto" class="d-flex align-center ga-2 w-100">
          <VIcon
            size="45"
            color="white"
            :icon="getToastIcon(massage.toastType)"
          />

          <div class="text-white">
            <h3 class="pb-2">
              {{ getToastTitle(massage.toastType) }}
            </h3>

            <p v-for="(item, i) in massage.message" :key="i">
              {{ item }}
            </p>
          </div>
        </VCol>
      </VRow>
    </template>
  </VSnackbar>
</template>

<script setup lang="ts">
import { VBtn, VCol, VIcon, VRow, VSnackbar } from 'vuetify/components'
import { useI18n } from 'vue-i18n'
import { ToastType } from '@/modules/Core/types/model/toast'
import { useToastStore } from '@/modules/Core/store'

const toastStore = useToastStore()
const { t } = useI18n()

function getToastColor(toastType: ToastType) {
  return toastType === ToastType.Success
    ? 'success-600'
    : toastType === ToastType.Warning
      ? 'warning-600'
      : toastType === ToastType.Error
        ? 'error-600'
        : ''
}

function getToastIcon(toastType: ToastType) {
  return toastType === ToastType.Success
    ? 'checkCircleFill'
    : toastType === ToastType.Warning
      ? 'warningCircleFill'
      : toastType === ToastType.Error
        ? 'error'
        : ''
}

function getToastTitle(toastType: ToastType) {
  return toastType === ToastType.Success
    ? t('toastSuccess.title')
    : toastType === ToastType.Warning
      ? t('toastWarning.title')
      : toastType === ToastType.Error
        ? t('toastError.title')
        : ''
}
</script>
